// extracted by mini-css-extract-plugin
module.exports = {"delayedContainer":"delayed_delayedContainer__ekYKV","delayedIcon":"delayed_delayedIcon__ZRPQE"};